// Collection Page Subscription Widget JavaScript
// This file should only be loaded on collection pages

$(document).ready(function() {
  
  // Subscription Widget on Collection
  $(document).on(
    "change",
    '.collection_product_form .custom_subscription_widgets .radio_btn_content .single_radio label input[type="radio"]',
    function () {
      var parent_form = $(this).parents(".collection_product_form"),
        sub_value = $(this).val(),
        selling_plan_id = $(parent_form)
          .find(".subscription_plans_inner select")
          .val();
      $(parent_form).find("label").removeClass("active");
      $(this).parents("label").addClass("active");
      if (sub_value == "subscription") {
        $(parent_form).find(".subscription_plans_inner").removeClass("hide");
        $(parent_form).find('[name="selling_plan"]').val(selling_plan_id);
      } else {
        $(parent_form).find(".subscription_plans_inner").addClass("hide");
        $(parent_form).find('[name="selling_plan"]').val("");
      }
    }
  );
  
  $(document).on(
    "change",
    ".collection_product_form .subscription_plans_inner select",
    function () {
      $(this)
        .parents(".collection_product_form")
        .find('[name="selling_plan"]')
        .val($(this).val());
    }
  );

  // Handle subscription plan select changes
  $(document).on(
    "change",
    '.collection_product_form select[name*="subscription_plan_select"]',
    function () {
      $(this)
        .parents(".collection_product_form")
        .find('[name="selling_plan"]')
        .val($(this).val());
    }
  );
  
  // Selling Plan Validation Function
  function validateSellingPlan(variantId, sellingPlanId, productHandle) {
    // If no product handle provided, try to get it from the form context
    if (!productHandle) {
      // On collection pages, we can't easily validate selling plans
      // So we'll skip validation and let Shopify handle the error
      console.log("Skipping selling plan validation on collection page");
      return Promise.resolve({ valid: true, skipped: true });
    }
    
    return fetch(`/products/${productHandle}.js`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        return response.json();
      })
      .then(product => {
        console.log("Product selling plan groups:", product.selling_plan_groups);
        
        // Check if variant exists
        var variant = product.variants.find(v => v.id.toString() === variantId);
        if (!variant) {
          throw new Error("Variant not found");
        }
        
        console.log("Variant selling plan allocations:", variant.selling_plan_allocations);
        
        // Check if selling plan is valid for this product
        var validSellingPlan = false;
        if (product.selling_plan_groups) {
          product.selling_plan_groups.forEach(group => {
            if (group.selling_plans) {
              group.selling_plans.forEach(plan => {
                if (plan.id.toString() === sellingPlanId) {
                  validSellingPlan = true;
                  console.log("Found matching selling plan:", plan);
                }
              });
            }
          });
        }
        
        return {
          valid: validSellingPlan,
          variant: variant,
          product: product
        };
      })
      .catch(error => {
        console.error("Error validating selling plan:", error);
        // On collection pages or if product data is unavailable,
        // we'll skip validation and let Shopify handle it
        return { valid: true, skipped: true, error: error.message };
      });
  }
  
  // Enhanced cart add with validation
  $(document).on("click", ".js_ATC_btn", function () {
    var _this = $(this),
      form_data = $(this).parents(".collection_product_form").serialize();
  
    // Validate form data before submission
    var parent_form = $(this).parents(".collection_product_form");
    var variant_id = parent_form.find('[name="id"]').val();
    var selling_plan = parent_form.find('[name="selling_plan"]').val();
    
    // Debug logging (can be removed in production)
    console.log("Subscription form submission:", variant_id, selling_plan);
    
    if (!variant_id) {
      console.error("No variant selected");
      return;
    }
    
    // Check if this is a subscription and validate selling plan
    var is_subscription = parent_form.find('input[name*="_sub_type"]:checked').val() === 'subscription';
    if (is_subscription && !selling_plan) {
      console.error("No selling plan selected for subscription");
      return;
    }
  
    $(_this).addClass("btn--loading");
  
    // Proceed with cart add
    performCartAdd(_this, form_data);
  });
  
  // Separated cart add function
  function performCartAdd(_this, form_data) {
    // Parse form data to get clean values
    var parent_form = $(_this).parents(".collection_product_form");
    var variant_id = parent_form.find('[name="id"]').val();
    var selling_plan = parent_form.find('[name="selling_plan"]').val();
    var quantity = parent_form.find('[name="quantity"]').val() || 1;
    
    // Use clean JSON data instead of serialized form data
    var cartData = {
      id: parseInt(variant_id),
      quantity: parseInt(quantity)
    };
    
    // Add selling plan if present
    if (selling_plan) {
      cartData.selling_plan = parseInt(selling_plan);
    }
    
    // console.log("Cart add data:", cartData); // Debug only
    
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: JSON.stringify(cartData),
      contentType: "application/json",
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      success: function (data) {
        $(_this).removeClass("btn--loading");
        // console.log("Cart add success:", data); // Debug only
        // Update Cart Drawer
        document.dispatchEvent(
          new CustomEvent("ajaxProduct:added", {
            detail: {
              product: data,
              addToCartBtn: _this,
            },
          })
        );
      },
      error: function (xhr, status, error) {
        $(_this).removeClass("btn--loading");
               // console.log("Cart add error details:", xhr.status, xhr.statusText); // Debug only
        
        var errorData = null;
        try {
          errorData = JSON.parse(xhr.responseText);
        } catch (e) {
          console.log("Could not parse error response as JSON");
        }
        
               // Log error for debugging
         var errorMessage = "Fehler beim Hinzufügen zum Warenkorb.";
         if (errorData && errorData.description) {
           errorMessage = errorData.description;
           
           // Handle specific selling plan errors
           if (errorMessage.includes("selling_plan") || errorMessage.toLowerCase().includes("subscription")) {
             errorMessage = "Problem mit dem Abonnement-Plan. Bitte überprüfen Sie Ihre Auswahl oder kontaktieren Sie den Support.";
           }
         }
         
         // Log error instead of showing alert
         console.error("Cart add failed:", errorMessage);
      },
    });
  }
  
  // Safe ReCharge Widget Initialization
  function initReChargeWidget() {
    // Check if ReCharge is available before trying to create widget
    if (typeof window.ReChargeWidget !== 'undefined' && window.ReChargeWidget.createWidget) {
      // Only initialize if we have ReCharge subscription blocks on the page
      var rechargeBlocks = document.querySelectorAll('[data-block-type*="recharge"], .recharge-widget, [id*="recharge"], .collection_product_form');
      
      if (rechargeBlocks.length > 0) {
        try {
          window.ReChargeWidget.createWidget({ productId: 7227396817092 });
        } catch (error) {
          console.warn("ReCharge widget initialization failed:", error);
        }
      } else {
        // console.log("No ReCharge containers found - skipping widget initialization"); // Debug only
      }
    } else {
      console.warn("ReCharge widget not available");
    }
  }
  
  // Initialize ReCharge widget when DOM is ready and after a delay to ensure scripts are loaded
  // Try to initialize immediately
  initReChargeWidget();
  
  // Also try after a delay in case the ReCharge script loads later
  setTimeout(initReChargeWidget, 2000);
  setTimeout(initReChargeWidget, 5000);
  
  // Listen for ReCharge script load
  var checkReCharge = setInterval(function() {
    if (typeof window.ReChargeWidget !== 'undefined') {
      initReChargeWidget();
      clearInterval(checkReCharge);
    }
  }, 1000);
  
  // Stop checking after 30 seconds
  setTimeout(function() {
    clearInterval(checkReCharge);
  }, 30000);

  // Variant Selector Initialization
  function initializeVariantSelectors(productId, productData) {
    if (typeof Shopify.OptionSelectors !== 'undefined') {
      var selectCallback = function(variant, selector) {
        var reg_price = variant.price,
            compaire_price = variant.compare_at_price;

        $(selector.variantIdField).parents('.collection_product_form').find('.regular_price').html(Shopify.formatMoney(reg_price, theme.settings.moneyFormat));
        if(reg_price < compaire_price){
          $(selector.variantIdField).parents('.collection_product_form').find('.compaire_price').html(Shopify.formatMoney(compaire_price, theme.settings.moneyFormat));
        }
      };

      new Shopify.OptionSelectors('product-select-' + productId, {
        product: productData,
        onVariantSelected: selectCallback,
        enableHistoryState: false
      });
    }
  }

  // Subscription Diagnostic Function
  function diagnoseSubscriptionIssues() {
    console.log("=== Subscription Diagnostic ===");
    
    // Check ReCharge availability
    console.log("ReCharge Widget available:", typeof window.ReChargeWidget !== 'undefined');
    
    // Check subscription forms
    var subscription_forms = $('.collection_product_form');
    console.log("Number of subscription forms found:", subscription_forms.length);
    
    subscription_forms.each(function(index, form) {
      var $form = $(form);
      var variant_id = $form.find('[name="id"]').val();
      var selling_plan = $form.find('[name="selling_plan"]').val();
      var subscription_plan_select = $form.find('select[name*="subscription_plan_select"]').val();
      
      console.log("Form " + (index + 1) + ":", {
        variant_id: variant_id,
        selling_plan: selling_plan,
        subscription_plan_select: subscription_plan_select,
        form_data: $form.serialize()
      });
    });
    
    console.log("=== End Diagnostic ===");
  }

  // Add diagnostic function to window for easy access
  window.diagnoseSubscriptions = diagnoseSubscriptionIssues;

  // Selling Plan Diagnostic Function
  function diagnoseSellingPlanIssues() {
    console.log("=== Selling Plan Diagnostic ===");
    
    // Get current product data
    if (typeof window.location !== 'undefined' && window.location.pathname.includes('/products/')) {
      var productHandle = window.location.pathname.split('/products/')[1];
      fetch(`/products/${productHandle}.js`)
        .then(response => response.json())
        .then(product => {
          console.log("Product ID:", product.id);
          console.log("Product Handle:", product.handle);
          console.log("Selling Plan Groups:", product.selling_plan_groups);
          
          if (product.selling_plan_groups && product.selling_plan_groups.length > 0) {
            product.selling_plan_groups.forEach((group, groupIndex) => {
              console.log(`Selling Plan Group ${groupIndex + 1}:`, group.name, group.id);
              if (group.selling_plans) {
                group.selling_plans.forEach((plan, planIndex) => {
                  console.log(`  Plan ${planIndex + 1}:`, {
                    id: plan.id,
                    name: plan.name,
                    description: plan.description
                  });
                });
              }
            });
          } else {
            console.warn("No selling plan groups found for this product!");
          }
          
          // Check variants
          console.log("Product Variants:");
          product.variants.forEach((variant, index) => {
            console.log(`Variant ${index + 1}:`, {
              id: variant.id,
              title: variant.title,
              available: variant.available,
              selling_plan_allocations: variant.selling_plan_allocations
            });
          });
        })
        .catch(error => {
          console.error("Error fetching product data:", error);
        });
    } else {
      console.log("Not on a product page - checking collection forms instead");
      
      // Check what selling plans are being used in forms
      $('.collection_product_form').each(function(index, form) {
        var $form = $(form);
        var selling_plan = $form.find('[name="selling_plan"]').val();
        var variant_id = $form.find('[name="id"]').val();
        
        console.log(`Form ${index + 1} - Variant: ${variant_id}, Selling Plan: ${selling_plan}`);
      });
    }
    
    console.log("=== End Selling Plan Diagnostic ===");
  }

  // Add to window for easy access
  window.diagnoseSellingPlans = diagnoseSellingPlanIssues;

  // Function to test selling plan compatibility
  function testSellingPlanCompatibility() {
    console.log("=== Testing Selling Plan Compatibility ===");
    
    var forms = $('.collection_product_form');
    var testPromises = [];
    
    forms.each(function(index, form) {
      var $form = $(form);
      var variant_id = $form.find('[name="id"]').val();
      var selling_plan = $form.find('[name="selling_plan"]').val();
      
      if (variant_id && selling_plan) {
        // Try to add to cart with minimal data to test compatibility
        var testData = {
          id: variant_id,
          quantity: 1,
          selling_plan: selling_plan
        };
        
        console.log(`Testing Form ${index + 1}: Variant ${variant_id} with Selling Plan ${selling_plan}`);
        
        var testPromise = fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(testData)
        })
        .then(response => {
          if (response.ok) {
            return response.json().then(data => {
              console.log(`✅ Form ${index + 1}: SUCCESS - Variant ${variant_id} is compatible with Selling Plan ${selling_plan}`);
              return { form: index + 1, variant_id, selling_plan, status: 'success', data };
            });
          } else {
            // Handle 422 errors specifically
            return response.json().then(errorData => {
              console.log(`❌ Form ${index + 1}: FAILED (${response.status}) - Variant ${variant_id} with Selling Plan ${selling_plan}:`, errorData);
              return { form: index + 1, variant_id, selling_plan, status: 'failed', error: errorData, statusCode: response.status };
            }).catch(() => {
              console.log(`❌ Form ${index + 1}: FAILED (${response.status}) - Variant ${variant_id} with Selling Plan ${selling_plan}: Could not parse error`);
              return { form: index + 1, variant_id, selling_plan, status: 'failed', error: 'Could not parse error', statusCode: response.status };
            });
          }
        })
        .catch(error => {
          console.log(`❌ Form ${index + 1}: NETWORK ERROR - Variant ${variant_id} with Selling Plan ${selling_plan}`, error);
          return { form: index + 1, variant_id, selling_plan, status: 'failed', error };
        });
        
        testPromises.push(testPromise);
      }
    });
    
    Promise.allSettled(testPromises).then(results => {
      console.log("=== Compatibility Test Results ===");
      var successes = [];
      var failures = [];
      
      results.forEach(result => {
        if (result.status === 'fulfilled') {
          if (result.value.status === 'success') {
            successes.push(result.value);
          } else {
            failures.push(result.value);
          }
        }
      });
      
      console.log(`✅ ${successes.length} selling plans are working correctly`);
      console.log(`❌ ${failures.length} selling plans have issues`);
      
      if (failures.length > 0) {
        console.log("Issues found:");
        failures.forEach(failure => {
          console.log(`  - Form ${failure.form}: Variant ${failure.variant_id} with Selling Plan ${failure.selling_plan}`);
          if (failure.error && failure.error.description) {
            console.log(`    Error: ${failure.error.description}`);
          }
        });
      }
      
      console.log("=== End Compatibility Test ===");
    });
  }

  // Add to window for easy access  
  window.testSellingPlanCompatibility = testSellingPlanCompatibility;

}); 